'use client';

import {
  FormLabel,
  freddyTheme,
  IconButton,
  Popover,
  Typography
} from '@coolblue-development/freddy';
import { InfoCircled } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { ReactNode, useState } from 'react';

type Props = {
  label: string;
  info?: string;
  component?: 'label' | 'legend';
  htmlFor?: string;
  children?: ReactNode;
};

export const FormLabelWithInfo = ({ label, info, component, htmlFor, children }: Props) => {
  const { t } = useTranslation('vacancyDetail.applicationForm.questions.matrixQuestion');

  const [isOpen, setIsOpen] = useState(false);
  const [popoverRef, setPopoverRef] = useState<HTMLButtonElement | null>(null);

  return (
    <div>
      <FormLabel
        component={component}
        htmlFor={htmlFor}
        description={
          info && (
            <IconButton
              ref={setPopoverRef}
              onClick={() => setIsOpen(true)}
              size='xsmall'
              alignSelf='center'
              type='button'
              aria-label={t('howToAnswer', { question: label })}
            >
              <InfoCircled fill={freddyTheme.color.icon.base} />
            </IconButton>
          )
        }
        sx={{ div: { alignSelf: 'center' } }}
      >
        {label}
      </FormLabel>
      {children}
      {info && (
        <Popover
          translations={{ ariaLabelClose: t('closePopover') }}
          referenceElement={popoverRef}
          open={isOpen}
          onClose={() => setIsOpen(false)}
          aria-label={t('howToAnswer', { question: label })}
        >
          {info.split('\n').map(line => (
            <Typography key={line} mb={0}>
              {line}
            </Typography>
          ))}
        </Popover>
      )}
    </div>
  );
};
